export default [
    {
        path: "consultorias/perfil",
        name: "perfil-consultor",
        component: () =>
            import(/* webpackChunkName: "perfil" */ "../perfil/views/perfil.vue"),
    },
]
